import { ACHIEVEMENTS, CHALLENGES } from './tabs'
import { BUTTONS, TITLE } from '../../../modals/universalModal'

export default {
  toggle: [
    {
      id: CHALLENGES,
      text: 'challenges.titles.challenges',
      action: CHALLENGES,
    },
    {
      id: ACHIEVEMENTS,
      text: 'challenges.titles.achieves',
      action: ACHIEVEMENTS,
    },
  ],
  lockNote: 'Выполните предыдущее задание, \nчтобы открыть следующие',
  doTask: {
    btnMod: 'doTask',
    className: 'custom-button_challenge custom-button_white challenge__item-button',
    timeout: 1000,
  },
  getReward: {
    btnMod: 'getReward',
    className: 'custom-button_challenge custom-button_white challenge__section-button',
    timeout: 1000,
  },
  buttonOpenModalWithClothes: {
    btnMod: 'showPrizes',
    className:
      'custom-button_challenge challenges__section-cloth-button _task__item-button_showPrizes',
    text: 'other.whatWillGet',
  },
  forFriendAchievementsModal: {
    modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
    components: [
      {
        type: TITLE,
        props: {
          modifier: 'padding-no',
          value: 'achievementsRewardContent.title',
        },
      },
      {
        type: BUTTONS,
        props: {
          buttons: [
            {
              text: 'other.continue',
              modalData: { action: 'close', data: { type: 'current' } },
            },
          ],
        },
      },
    ],
  },
}
